import { render, staticRenderFns } from "./IconTooltip.vue?vue&type=template&id=1539306d"
import script from "./IconTooltip.vue?vue&type=script&lang=js"
export * from "./IconTooltip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports